import store, { snackbarActions } from '@apply/adminStore';

const sendMessage = (isOpen: boolean, message: string, variant: string) => {
    if (!variant) {
        variant = 'info';
    }
    if (!message) {
        isOpen = false;
    }
    store.dispatch(snackbarActions.updateSnackbar({ isOpen, message, variant }));
};

export const snackbarError = (message: string) => {
    sendMessage(true, message, 'error');
};

export const snackbarSuccess = (message: string) => {
    sendMessage(true, message, 'success');
};

export const snackbarInfo = (message: string) => {
    sendMessage(true, message, 'info');
};

export const snackbarWarning = (message: string) => {
    sendMessage(true, message, 'warning');
};

export const snackbarClear = () => {
    store.dispatch(snackbarActions.updateSnackbar({ isOpen: false }));
};
